import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useWelderPicture(id: string) {
  return useQuery(queryKeys.welder.picture(id), () => {
    return api.getWelderPicture(id);
  });
}
